export default function (Vue) {
        
        
        Vue.dmMessages = {
            
            dmErrors: {
                field:'',
                message: ''
            },
            dmSuccesses: {
                field:'',
                message:''
            },
            
            addError: function(field, message) {
                
                if(typeof field !=="string" || typeof message !=="string" ) {
                    return
                }
                
                this.cleanBags()
                this.dmErrors.field = field                
                this.dmErrors.message=message
                               
                
            },
            addSuccess: function(field, message) {
                
                if(typeof field !=="string" || typeof message !=="string" ) {
                    return
                }
                this.cleanBags()
                this.dmSuccesses.field = field                
                this.dmSuccesses.message=message
            },
            cleanBags: function(){
                                                    
                    this.dmSuccesses.field=''
                    this.dmSuccesses.message=''
                                
                    this.dmErrors.field=''
                    this.dmErrors.message=''                
                
            },
            anySuccess: function() {
                
                return this.dmSuccesses.field !=='' && this.dmSuccesses.message!==''
            },
            anyError: function() {
                
                return this.dmErrors.field !='' && this.dmErrors.message !=''
            },            
            getSuccesses: function() {
                if (this.anySuccess()) {
                    return this.dmSuccesses
                }
                return []
            },
            getErrors: function() {
                console.log(this.dmErrors)
                return this.dmErrors         
                
            }
                              
                        
        }
        Object.defineProperties(Vue.prototype, {
        
            $dmMessages: {
                get: function() {
                    return Vue.dmMessages;
                }
            }
                
        });
}



// WEBPACK FOOTER //
// ./src/packages/dmMessages/DmMessages.js